var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCasa = function SvgCasa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.5 26.5"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.1 15.93h12.46V26.5H7.1z",
    fill: "#2ad2c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.28 11.65-8.57-8.63C15.78 1.07 14.71 0 13.25 0s-2.53 1.07-4.46 3.02L.22 11.65c-.29.29-.29.77 0 1.06s.77.29 1.06 0l1.09-1.1v12.14c0 1.52 1.23 2.75 2.75 2.75h3.89l.04-5.53c.54-2.3 2.5-3.33 4.2-3.33s3.66 1.03 4.2 3.33l.02.17.02 5.36h3.88c1.52 0 2.75-1.23 2.75-2.75V11.61l1.09 1.1c.29.29.77.3 1.06 0 .29-.29.3-.77 0-1.06Z",
    fill: "#fff"
  }))));
};
export default SvgCasa;